import { useEffect, useState } from 'react';
import { FAQ } from '../ui/faq-section';
import { client } from '@/sanity/client';

export const Faq = () => {
	const [faqItems, setFaqItems] = useState([]);

	useEffect(() => {
		const fetchFaqItems = async () => {
			const data = await client.fetch(`*[_type == "faqItem"]{
				question,
				answer
			}`);
			setFaqItems(data);
		};

		fetchFaqItems();
	}, []);

	return (
		<div className='flex flex-col justify-center items-center px-18  w-full  rounded-none md:px-18 max-md:max-w-full'>
			<FAQ faqItems={faqItems} />
		</div>
	);
};
